import lodash from "lodash";
import { FormInformation } from "@/modules/GeneralRules/models/FormInformationMapped.model";
import { FormOperation } from "@/modules/GeneralRules/models/FormOperation.model";
import { FORM_VALIDATORS } from "@/shared/constants/FormConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  DATA_TYPES,
  FORM_ACTION_CONSTANTS,
  OPERATION_INIT
} from "../../constants/FormActionModal.constants";
import { FormStatus } from "@/modules/FormTemplate/models/FormStatus";
import { Field } from "@/modules/FormTemplate/models/Field";
import CalculatorComponent from "../CalculatorComponent/CalculatorComponent.vue";
import Vuetify from "vuetify";
import LogicOperationComponent from "../LogicOperationComponent/LogicOperationComponent.vue";
import { LogicalField } from "@/modules/GeneralRules/models/LogicalField.model";
import { KeyValue } from "@/shared/models/KeyValue";
import Snackbar from "@/shared/components/Snackbar/Snackbar";

Vue.use(Vuetify);
@Component({
  name: "OperationElement",
  components: {
    CalculatorComponent,
    LogicOperationComponent
  }
})
export default class OperationElement extends Vue {
  @Prop({ default: 0 }) index!: number;
  @Prop() formToGenerate!: FormStatus | string;
  @Prop() formTemplates!: FormStatus[];
  @Prop() formInformationArray!: FormInformation[];
  @Prop() formOperationsArray!: FormOperation[];
  @Prop() formOperation!: FormOperation;

  primaryRoundBtnClass = STYLE_CLASSES.PRIMARY_ROUND_BTN;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  requiredFieldObject = [FORM_VALIDATORS.REQUIRED_OBJECT];
  requiredFieldTxt = [FORM_VALIDATORS.REQUIRED_FIELD];
  requiredNumberTxt = [FORM_VALIDATORS.NUMBER_FIELD];

  SAVE_OPERATION = FORM_ACTION_CONSTANTS.LABELS.SAVE_OPERATION;
  SELECT_OPERATION = FORM_ACTION_CONSTANTS.LABELS.SELECT_OPERATION;
  OBJ_FIELD = FORM_ACTION_CONSTANTS.LABELS.OBJ_FIELD;
  INFO_GET = FORM_ACTION_CONSTANTS.LABELS.INFO_GET;
  CALCULATOR = FORM_ACTION_CONSTANTS.LABELS.CALCULATOR;
  NO_FIELDS = FORM_ACTION_CONSTANTS.LABELS.NO_FIELDS;
  NO_NUMERIC_FIELDS = FORM_ACTION_CONSTANTS.LABELS.NO_NUMERIC_FIELDS;

  ARITHMETIC = FORM_ACTION_CONSTANTS.FIELD_OPERATION.ARITHMETIC;
  GET_COUNT = FORM_ACTION_CONSTANTS.FIELD_OPERATION.GET_COUNT;
  LOGIC = FORM_ACTION_CONSTANTS.FIELD_OPERATION.LOGIC;
  SAME_FIELD = FORM_ACTION_CONSTANTS.FIELD_OPERATION.SAME_FIELD;
  SAME_FIELD_OPERATION = FORM_ACTION_CONSTANTS.LABELS.SAME_FIELD_OPERATION;
  OPERATIONS = [
    FORM_ACTION_CONSTANTS.FIELD_OPERATION.ARITHMETIC,
    FORM_ACTION_CONSTANTS.FIELD_OPERATION.GET_COUNT,
    FORM_ACTION_CONSTANTS.FIELD_OPERATION.LOGIC,
    FORM_ACTION_CONSTANTS.FIELD_OPERATION.SAME_FIELD
  ];
  SAME_FIELD_OPERATORS = [
    FORM_ACTION_CONSTANTS.SAME_FIELD_OPERATORS.ADDITION,
    FORM_ACTION_CONSTANTS.SAME_FIELD_OPERATORS.AVERAGE,
    FORM_ACTION_CONSTANTS.SAME_FIELD_OPERATORS.HIGHER,
    FORM_ACTION_CONSTANTS.SAME_FIELD_OPERATORS.SMALLER
  ];

  localFormOperation: FormOperation = lodash.cloneDeep(OPERATION_INIT);

  value = "";
  resetField = 0;
  operationValidation = false;
  localFields: Field[] = [];
  localInformation: FormInformation[] = [];
  key = 0;

  mounted() {
    this.localFormOperationUpdate();
    this.changeFields();
  }

  @Watch("formOperation", { deep: true })
  localFormOperationUpdate() {
    this.localFormOperation = this.formOperation;
    this.changedInformation();
  }

  changedType() {
    if ((this.localFormOperation.type as KeyValue).key === this.LOGIC.key) {
      this.initializeLogicalFields();
    } else {
      delete this.localFormOperation.logicalFields;
    }
    this.changeFields();
    this.clearData();
    this.editOperation();
    this.key++;
  }

  initializeLogicalFields() {
    this.localFormOperation.logicalFields = [];
    const tempField: LogicalField = {
      key: "",
      operator: "",
      value: ""
    };
    this.localFormOperation.logicalFields.push(tempField);
  }

  @Watch("formInformationArray", { deep: true })
  changedInformation() {
    this.localInformation = this.formInformationArray;
  }

  @Watch("formToGenerate", { deep: true })
  changeFields() {
    if (this.formToGenerate) {
      if (
        (this.localFormOperation.type as KeyValue).key ===
          this.ARITHMETIC.key ||
        (this.localFormOperation.type as KeyValue).key === this.SAME_FIELD.key
      ) {
        this.localFields = (this.formToGenerate as FormStatus).fields.filter(
          field => field.schema.type === DATA_TYPES.NUMBER
        );
      } else {
        this.localFields = (this.formToGenerate as FormStatus).fields;
      }
      return;
    }
    this.localFields = [];
  }

  selectedSameFieldOperation() {
    delete this.localFormOperation.value;
    this.editOperation();
  }

  changedField(field: Field) {
    const operation = this.formOperationsArray.filter(
      (operation, index) =>
        (operation.fieldToSet as Field).key === field.key &&
        index !== this.index
    );
    if (operation.length === 0) {
      this.localFormOperation.fieldName = field ? field.schema.title : "";
      this.editOperation();
    } else {
      this.localFormOperation.fieldToSet = "";
      this.resetField = 1 - this.resetField;
      Snackbar.popInfo(FORM_ACTION_CONSTANTS.SNACKBAR.ONLY_ONE_OPERATION);
    }
  }

  updateLogicalOperation(logicalField: LogicalField, index: number) {
    if (this.localFormOperation.logicalFields) {
      Vue.set(this.localFormOperation.logicalFields, index, logicalField);
    }
    this.editOperation();
  }

  updateCalculator(operation: string) {
    this.localFormOperation.operation = operation;
    this.editOperation();
  }

  addLogicalField(index: number) {
    if (
      this.localFormOperation.logicalFields &&
      this.localFormOperation.logicalFields.length === index + 1
    ) {
      const newLogicalField: LogicalField = {
        key: "",
        operator: "",
        value: ""
      };
      this.localFormOperation.logicalFields.push(newLogicalField);
      this.editOperation();
    }
  }

  clearData() {
    this.localFormOperation.fieldToSet = "";
    this.localFormOperation.fieldName = "";
    delete this.localFormOperation.informationKey;
    delete this.localFormOperation.operation;
    delete this.localFormOperation.value;
  }

  deleteLogicalField(index: number) {
    if (this.formOperation.logicalFields) {
      const tempData = [];
      for (let i = 0; i <= index; i++) {
        tempData.push(this.formOperation.logicalFields[i]);
      }
      this.localFormOperation.logicalFields = tempData;
    }
    this.editOperation();
  }

  editOperation() {
    this.$emit(
      FORM_ACTION_CONSTANTS.EVENTS.OPERATIONS.EDIT_OPERATION,
      this.localFormOperation,
      this.index
    );
  }
}
